import DateFnsUtils from '@date-io/date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
  datePicker: {
    width: 50,
    float: 'right',
  },
}));

const DatePickerField = ({
  datePickerProps,
  label,
  input: { name, value, onChange },
  meta: { touched, error, warning },
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePicker
        animateYearScrolling
        label={label}
        value={value || new Date()}
        className={classes.datePicker}
        {...restProps}
        {...datePickerProps}
        onChange={onChange}
      />
    </MuiPickersUtilsProvider>
  );
};

DatePickerField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,
};

export default DatePickerField;
